module.exports = __webpack_public_path__ + "img/TAJO.b54bada4.png";